const amt_admin = require('amt_admin').default;
const app = require('angular').module('ww2_analytics.economics', [amt_admin]);


function configure_app($stateProvider) {
  $stateProvider
    .state('amt.ww2.economics', {
      url: '/economics',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 803,
        title: 'Economics',
        role: 'economics',
      },
      menu: {
        fa: 'usd',
        childs: [
          {state: 'amt.ww2.economics.campaign_installs', fa: 'usd'},
          {state: 'amt.ww2.economics.campaign', fa: 'usd'},
          {state: 'amt.ww2.economics.power', fa: 'usd'},
          {state: 'amt.ww2.economics.premium_passes_ltv', fa: 'usd'},
        ],
      },
    })
    .state('amt.ww2.economics.premium_passes_ltv', require('./premium_passes_ltv').default)
    .state('amt.ww2.economics.campaign_installs', require('./campaign_installs').default)
    .state('amt.ww2.economics.campaign', require('./campaign').default)
    .state('amt.ww2.economics.power', require('./power').default)
}

app.config(['$stateProvider', configure_app]);
app.service('economics_api', [
  'jsonrpc',
  function(jsonrpc) {
    var service = jsonrpc.newService('economics');
    this.premium_passes_ltv_table = service.createMethod('premium_passes_ltv_table');
    this.campaign_installs_table = service.createMethod('campaign_installs_table');
  }
]);

export default app.name;
